var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, computed, observable } from "mobx";
let StoreBase = /** @class */ (() => {
    class StoreBase {
        constructor(name) {
            this.state = "ready";
            this.lastUpdated = new Date();
            this.name = name;
        }
        setState(state) {
            //console.log(`${this.name}: ${this.state} -> ${state}`);
            this.state = state;
            if (state === "ready") {
                this.lastUpdated = new Date();
            }
        }
        setError(error) {
            this.error = error;
            this.setState("error");
        }
        get isReady() {
            return this.state === "ready";
        }
        get isUpdating() {
            return this.state === "updating";
        }
        get hasErrors() {
            return this.state === "error";
        }
        get isWorking() {
            return !this.isReady && !this.hasErrors;
        }
    }
    __decorate([
        observable,
        __metadata("design:type", String)
    ], StoreBase.prototype, "state", void 0);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], StoreBase.prototype, "setState", null);
    __decorate([
        computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], StoreBase.prototype, "isReady", null);
    __decorate([
        computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], StoreBase.prototype, "isUpdating", null);
    __decorate([
        computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], StoreBase.prototype, "hasErrors", null);
    __decorate([
        computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], StoreBase.prototype, "isWorking", null);
    return StoreBase;
})();
export { StoreBase };
//# sourceMappingURL=StoreBase.js.map